const prefetchedUrls = new Set();

function getInternalPageUrl(target) {
  const link = target.closest?.('a[href]');
  if (!link || link.target === '_blank' || link.hasAttribute('download')) return null;

  const url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin || url.href === window.location.href) return null;
  if (!['http:', 'https:'].includes(url.protocol)) return null;

  const excludedPath = /^(\/cart|\/checkout|\/account|\/apps)(\/|$)/;
  if (excludedPath.test(url.pathname)) return null;

  url.hash = '';
  return url.href;
}

function prefetchPage(event) {
  const url = getInternalPageUrl(event.target);
  if (!url || prefetchedUrls.has(url)) return;

  prefetchedUrls.add(url);
  const hint = document.createElement('link');
  hint.rel = 'prefetch';
  hint.as = 'document';
  hint.href = url;
  document.head.appendChild(hint);
}

document.addEventListener('pointerdown', prefetchPage, { capture: true, passive: true });
document.addEventListener('pointerover', prefetchPage, { capture: true, passive: true });
document.addEventListener('focusin', prefetchPage, { capture: true });

function getVisibleCartCount() {
  const counter = document.querySelector('[data-acw-cart-count]');
  const count = Number.parseInt(counter?.textContent?.trim() || '0', 10);

  return Number.isFinite(count) ? count : 0;
}

function updateVisibleCartCounts(count) {
  document.querySelectorAll('[data-acw-cart-count]').forEach((counter) => {
    counter.textContent = String(count);
  });
}

document.addEventListener('cart:update', (event) => {
  const itemCount = Number(event.detail?.data?.itemCount);

  if (!Number.isFinite(itemCount)) return;

  const isProductAddition = event.detail?.data?.source === 'product-form-component';
  const nextCount = isProductAddition ? getVisibleCartCount() + itemCount : itemCount;

  updateVisibleCartCounts(Math.max(0, nextCount));
});
